module.exports = __webpack_public_path__ + "img/Gehölz.c1c471c0.svg";